import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';

import { ContentContext } from 'Components/hooks/context';
import Globe from './Globe';
import Logo from 'Components/common/Logo';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import isEqual from 'lodash/isEqual';

const Title = ({ countries, stepDuration, delay }) => {
  const [mapFocus, setMapFocus] = useState(null);
  const [spinMap, setSpinMap] = useState(false);
  const [showLogo, setShowLogo] = useState(false);
  const [showGenerating, setShowGenerating] = useState(false);

  const { common: content } = useContext(ContentContext);

  useEffect(() => {
    const timeouts = countries.map((c, i) => {
      return setTimeout(() => setMapFocus(c), i * stepDuration + delay);
    });
    return () => timeouts.forEach(timeout => clearTimeout(timeout));
  }, [countries, stepDuration, delay]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSpinMap(true);
      setShowLogo(true);
      setMapFocus(countries.reverse());
    }, (stepDuration * countries.length) + delay);
    return () => clearTimeout(timeout);
  }, [countries, stepDuration, delay]);

  return (
    <div className={classnames(component)}>
      <div className='globe'>
        <Globe
          location={mapFocus}
          spin={mapFocus ? spinMap : true}
          fetchedJson={() => setShowGenerating(true)}
        />
        <AnimatePresence>
          {(!showLogo && showGenerating) && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.75 }}
              transition={{ ease: 'easeIn', duration: 1 }}
              exit={{ opacity: 0 }}
              className='generating'
            >
              <div className='center'>
                <div className='ring-loader'><div /><div /><div /><div /></div>
                {content.title.generating}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <div className='title'>
        <Logo showAnimation={showLogo} withoutLink />
      </div>
    </div>
  );
};

const propsAreEqual = (prevProps, nextProps) => {
  if (!isEqual(prevProps.countries, nextProps.countries)) return false;
  return true;
};

export default React.memo(Title, propsAreEqual);
